import React from "react";
import classes from "./Footer.module.css";

const Footer = () => {
  return (
    <footer className={classes.footer}>
      <a href="https://www.davidebalice.dev" target="_blank" rel="noreferrer">
        www.davidebalice.dev
      </a>
    </footer>
  );
};

export default Footer;
